// extracted by mini-css-extract-plugin
module.exports = {"buttons":"DealOptionsForm__buttons___11SRF"};